export const bind = ( func, ...args ) =>
    func.bind(null, ...args);
